import { fg } from '@atlassian/jira-feature-gating';

const UseNodeIdForRowKeyDisabledRelayProvider = {
	get(): boolean {
		return !fg('use_node_id_for_row_key');
	},
};

export default UseNodeIdForRowKeyDisabledRelayProvider;
